import { ShieldCheck } from 'lucide-react';
import { useState, useEffect } from 'react';
import { LanguageSwitcher } from '../LanguageSwitcher';

export function Features({
  copy,
  sidebarImage,
  analyticsSlides,
}) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    setCurrentSlide(0);
  }, [analyticsSlides]);

  useEffect(() => {
    if (!analyticsSlides?.length) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % analyticsSlides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [analyticsSlides?.length]);

  const slide = analyticsSlides?.[currentSlide];

  return (
    <section className="space-y-8">
      <article className="grid gap-8 overflow-hidden rounded-lg border border-slate-200 bg-white p-5 shadow-sm sm:p-6 lg:grid-cols-[minmax(0,1.12fr)_minmax(0,0.88fr)] lg:items-center lg:p-8">
        <div>
          <div className="overflow-hidden rounded-lg border border-slate-200 bg-slate-50 p-2 sm:p-3">
            <img
              src={slide?.image}
              alt={copy.analytics.imageAlt || slide?.title}
              className="aspect-[16/9] w-full rounded-md object-contain shadow-lg"
              loading="lazy"
            />
          </div>
        </div>

       <div className="max-w-xl transition-all duration-500">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-700">
            {copy.analytics.eyebrow}
          </p>

          {slide && (
            <>
              <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                {slide.title}
              </h2>

              <p className="mt-4 text-base leading-7 text-slate-600">
                {slide.description}
              </p>
            </>
          )}
        </div>
      </article>

      {/* BLOCO DE IDIOMA */}
      <article className="grid gap-8 overflow-hidden rounded-lg border border-slate-200 bg-white p-5 shadow-sm sm:p-6 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] lg:items-center lg:p-8">
        <div className="max-w-xl">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-700">
            {copy.language.eyebrow}
          </p>

          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            {copy.language.title}
          </h2>

          <p className="mt-4 text-base leading-7 text-slate-600">
            {copy.language.description}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <LanguageSwitcher variant="landing" />
          </div>
        </div>

        <div className="flex justify-center lg:justify-end">
          {sidebarImage && (
            <div className="grid w-full max-w-lg gap-5 rounded-lg border border-blue-100 bg-blue-50/60 p-5 shadow-sm sm:p-6 md:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] md:items-center">
              <div className="overflow-hidden rounded-lg border border-blue-100 bg-white p-3">
                <img
                  src={sidebarImage.src}
                  alt={sidebarImage.alt}
                  className="max-h-96 w-full rounded-md object-contain shadow-sm"
                />
              </div>

              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700">
                  {copy.sidebar.eyebrow}
                </p>

                <h3 className="mt-2 text-xl font-semibold text-slate-900">
                  {copy.sidebar.title}
                </h3>

                <p className="mt-2 text-sm leading-6 text-slate-600">
                  {copy.sidebar.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </article>

      {/* SEGURANÇA */}
      <div className="rounded-lg border border-blue-100 bg-blue-50 p-6 sm:p-8 lg:p-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:justify-between">
          <div className="max-w-2xl">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-blue-700 text-white">
              <ShieldCheck className="h-6 w-6" />
            </div>

            <p className="mt-5 text-sm font-semibold uppercase tracking-[0.24em] text-blue-700">
              {copy.security.eyebrow}
            </p>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              {copy.security.title}
            </h2>

            <p className="mt-4 text-base leading-7 text-slate-600">
              {copy.security.description}
            </p>
          </div>

          <div className="grid gap-4 lg:max-w-xl lg:flex-1">
            {copy.security.items.map((item) => (
              <div key={item} className="rounded-lg border bg-white px-5 py-4 text-sm shadow-md">
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
